import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import TableHeader from '../../atoms/table/TableHeader';
import TableHeaderCell from '../../atoms/table/TableHeaderCell';
const StyledTableHeaderCell = styled(TableHeaderCell) `
    min-width: 90px;
    flex: 0;
`;
const DocumentTableHeader = () => {
    return (_jsxs(TableHeader, { children: [_jsx(TableHeaderCell, { children: "Datum" }), _jsx(TableHeaderCell, { children: "Documentsoort" }), _jsx(StyledTableHeaderCell, { children: "Downloaden" })] }));
};
export default DocumentTableHeader;
